// 中文翻译
export const zh = {
  // 导航
  nav: {
    aboutMe: '关于我',
    challenge100: 'Challenge 100',
    spy100: 'Spy 100',
    launch100: 'Launch 100',
    ship100: 'Ship 100',
    grow100: 'Grow 100',
    projects: '项目',
    blog: '博客',
    contact: '联系',
    resources: '资源',
    pearl: 'Pearl 框架',
    methodology: '方法论',
    faq: '常见问题',
  },
  
  // 首页 Hero
  hero: {
    title1: '从系统崩溃',
    title2: '到重建自我',
    subtitle: '王海生 · 用40年踩过的坑，为你点亮一盏灯',
    soundOn: '打开声音',
  },
  
	  // 服务/项目
	  services: {
	    badge: 'Recent Work',
	    title: '精选项目',
	    subtitle: '心血之作展示',
	    viewMore: '查看更多',
	    darkroomNote: '每一件作品都在我们的创意暗房中精心打造，确保每一个细节都精准捕捉您的愿景的本质，兼具精确性和艺术感。',
	  },

	  // 首页：个人简介区（Portfolio）
	  portfolio: {
	    badge: '关于我',
	    title: '你好，我是王海生',
	    subtitle: '一个从尿床到创业，把人生 bug 变成产品 feature 的探索者',
	    video: {
	      title: '王海生自我介绍',
	      url: 'https://www.youtube.com/embed/YOUR_VIDEO_ID',
	      caption: '3 分钟了解我的故事：从系统崩溃到重建自我',
	    },
	    identities: {
	      title: '我的三重身份',
	      trauma: {
	        title: '创伤探索者',
	        description: '从学前班尿床到 30 岁荨麻疹，40 年的身心困境让我成为了自己的研究员。',
	      },
	      product: {
	        title: '产品经理',
	        description: '12 年 AI+医疗经验，从 800+ 家医院的数据里，学会了如何把复杂问题简单化。',
	      },
	      entrepreneur: {
	        title: '创业者',
	        description: '2024 年开始将个人经历产品化，相信每个人的痛苦都能成为别人的光。',
	      },
	    },
	    story: {
	      p1: '我不是成功学导师，也不是心灵鸡汤博主。我只是一个在人生的各种「系统故障」中摸爬滚打了 40 年的普通人。',
	      p2: '从小时候的尿床羞耻，到成年后的荨麻疹折磨，从职场的技术挑战，到内心的创伤修复——我发现，\n\n每一次崩溃，都是下一次重建的开始。',
	      p3: '现在，我把这些「人生 bug」整理成了可复用的「修复补丁」，希望能为同样在黑暗中摸索的你，点亮一盏灯。',
	    },
	    stats: {
	      yearsProduct: { value: '12+', label: '年产品踩坑经验' },
	      hospitals: { value: '800+', label: '医院见过的奇葩需求' },
	      yearsTrauma: { value: '40', label: '年创伤探索之路' },
	      rebuilds: { value: '∞', label: '次从崩溃到重建' },
	    },
	  },

	  // 首页：社交频道区（Awards / Social）
	  social: {
	    badge: '社交与频道',
	    title: 'Social & Channels',
	    subtitle: '在不同平台上找到我。',
	  },

		  // 首页：人生时间线区（About Timeline）
		  aboutTimeline: {
		    badge: '我的旅程',
		    title: '人生时间线',
		    subtitle: '从医疗 AI 到创伤探索的 12 年历程',
		    steps: [
		      {
		        title: '2012 · AI 起步',
		        description: '进入人工智能领域，从 0 到 1 搭建产品线',
		      },
		      {
		        title: '2014 · 医疗转型',
		        description: '转入医疗行业，产品经理职业起步',
		      },
		      {
		        title: '2017 · 医疗科技创业',
		        description: '主导智能超声产品，推动 AI+医疗 融合',
		      },
		      {
		        title: '2020 · 创伤探索',
		        description: '开始深度自我修复与内在探索',
		      },
		      {
		        title: '2024 · 经历产品化',
		        description: '创建 borninsea，将个人经历转化为产品',
		      },
		    ],
		    stats: {
		      experience: '12 年经验',
		      domain: 'AI + 医疗',
		      philosophy: '持续迭代',
		    },
		  },
  
  // 关于页面
  about: {
    backHome: '返回首页',
    title: '关于我',
    subtitle: '我是一个多面体。每一面都承载着不同的故事、不同的使命、不同的我。',
    quote: '"我们不必变得完美。我们只需要，认清自己系统里的"病毒"与"漏洞"，然后，学会与它共处、修复、并最终让它为我所用。"',
    
    identities: {
      trauma: {
        title: '创伤探索者',
        subtitle: 'Trauma Explorer',
        description: '四十年的跋涉与觉醒，从原生家庭到自我关系的全线崩溃与重建。我把这段旅程熬成了韧性教练体系、开源复杂创伤数据集、创伤炼金工作坊。',
      },
      entrepreneur: {
        title: '创业者',
        subtitle: 'Entrepreneur',
        description: '从0到1的产品构建者，专注于将个人经历和专业知识产品化。探索AI时代的个人IP和数字产品。',
      },
      resume: {
        title: '职业履历',
        subtitle: 'Resume',
        description: '985硕士，跨领域探索者。从学术到实践，从技术到人文的多元职业路径。',
      },
    },
    
    // 创伤探索者页面
    trauma: {
      title: '创伤探索者',
      subtitle: 'Trauma Explorer',
      greeting: '各位，深夜好。',
      sections: {
        beginning: {
          title: '我的人生，是从一场离别开始的',
          content: [
            '我一岁多，父母就离婚了。我的生母有智力障碍，我的父亲是残疾人。他也没有父亲，我的奶奶从三岁开始守寡，独自养大了六个儿子。我的继母人很好，但她也从小失去了妈妈，是她的父亲一手带大了孩子们。他们三个都是农民，都不识字。',
            '这意味着什么？',
            '意味着我从有记忆起，就不知道"被妈妈照顾"是什么感觉。我不知道被拥抱的温度，不知道委屈时可以扑向谁的怀里。小学音乐课，听到《世上只有妈妈好》时，眼泪会自己掉下来。'
          ]
        },
        slowStart: {
          title: '我的人生，开局就被按下了慢放键',
          content: [
            '别人一岁会走，我三岁还站不稳。别人两岁说话，我五岁才吐出清晰的词。',
            '我的童年，写满了难堪。学前班时，好几次大便失禁在裤子里。夜里尿床，一直尿到十二岁。不记得有多少个清晨，是从冰冷而羞耻的潮湿中醒来。',
            '我的身体，好像听不懂这个世界的话。三十多年来，我几乎每天都在手抖，经常腹泻。所以我从来不敢吃冰棍，不敢喝别人递来的饮料。'
          ]
        },
        silence: {
          title: '我是这个家里，最沉默的孩子',
          content: [
            '父亲一个生气的眼神，会让我感到窒息。向父母提一个简单的要求，我花了三十年才敢尝试。'
          ],
          list: [
            '在池塘差点溺死，不敢说。',
            '拇指被玻璃割得快要断掉，鞋里浸满了血，回家不敢吱声。',
            '在学校被嘲讽、欺负、打压，父母永远不会知道你的难受。',
            '高中住校总是吃不饱，个子三年没长，他们好像也没看见。',
            '我不知道下雨天有人送伞是什么感觉。'
          ],
          conclusion: [
            '我人生学会的第一件事，就是对自己说话——在路上，在屋里，在每一个无人回应的时刻。',
            '这些，不是故事，是我每一天都必须咽下去的真实。'
          ]
        },
        escape: {
          title: '我以为努力就能逃离',
          content: [
            '我以为，只要我足够努力，跑得足够远，就能把这一切甩在身后。',
            '我用这具迟缓、漏雨的身体，走了四十年。走到了985，走到了硕士。靠自己的努力，把老家那间让人看了心酸的西北土房，翻修成了父母能安心住下的家。',
            '但后来，我才惊恐地发现：我的人走出了那个家，我的心没有。它被设定好的程序，把我拖进了另一场更隐秘、更漫长的噩梦。'
          ]
        },
        relationships: {
          title: '亲密关系中的复刻',
          content: [
            '当我开始建立自己的亲密关系时，我复制了童年的全部剧本。我毫无知觉地，选择了一段充满忽视、消耗、且无法沟通的关系。我像一个设定好程序的机器人，把所有的爱，等同于"单向的、痛苦的、漫长的付出"。我支付全部费用，忍受全部冷漠，并坚信"这就是我存在的价值，这就是我应得的爱"。',
            '我清醒地看着自己像一块电池被耗干，像一座大坝在裂缝，我精准地预言了结局，却从未想过离开。因为离开，意味着对我过去所有"付出"的背叛，意味着我构建的整个"负责"的人生意义，会瞬间崩塌。'
          ],
          quote: '你看，这就是情感创伤最狡猾的地方。它不仅仅让你痛苦，它还会扭曲你对"爱"和"价值"的认知，让你心甘情愿地、主动地去重复那种痛苦，并把那当成你唯一的宿命和勋章。'
        },
        sharing: {
          title: '为什么要分享这些',
          content: [
            '今天，我把这些最私密、最脆弱的"人生故障报告"和"情感程序错码"，全部摊开在这里。',
            '不是为了换取一句"好可怜"。',
            '是为了让你看到：创伤是如何像病毒一样，感染我们的选择，绑架我们的人生。',
            '更是为了告诉你：如果连我这样，从身体到家庭，再到成年后的亲密关系，全线崩溃的人生，都能一步步完成"系统杀毒"和"程序重写"——那么，你心里觉得自己逃不出的迷宫，或许，真的只是一段被植入的错误代码。'
          ]
        },
        threeLights: {
          title: '三盏灯',
          intro: '我在这条黑路上走了四十年，经历了从原生家庭到自我关系的全线崩溃与重建。现在，我想回头，为还在类似迷宫里打转的人，点亮三盏灯。',
          lights: [
            {
              name: '看见',
              description: '让你看清脚下的路，原来布满了古老的代码陷阱。'
            },
            {
              name: '诊断',
              description: '给你工具，分析自己的"情感程序"究竟在哪里被劫持。'
            },
            {
              name: '重写',
              description: '照着你的伤疤，告诉你：这里不仅能愈合，你还能获得源代码的权限，亲手写下未来的剧情。'
            }
          ]
        },
        conclusion: {
          message: [
            '如果你也曾在黑夜里蜷缩，不知痛苦从何而来。',
            '如果你也曾在关系里耗尽自己，却觉得别无选择。',
            '如果你也觉得，内心有个声音总在重复熟悉的悲剧脚本。',
            '那么，请看看我。'
          ],
          proof: [
            '我不是你的榜样，我是一个"可行性论证"。',
            '一个微小的、具体的证据：证明一个人，即便被最深的创伤编写了初始程序，也依然可以通过艰难的自我调试，夺回人生的编辑权。并且，可以用这双修复过系统的手，为后来者，提供一份详细的"技术手册"。'
          ],
          finalQuote: '我们不必变得完美。我们只需要，认清自己系统里的"病毒"与"漏洞"，然后，学会与它共处、修复、并最终让它为我所用。',
          invitation: [
            '如果你也觉得自己启动太慢，漏洞太多，总在重复该死的错误。',
            '那么，请记住我此刻的样子。',
            '关注我。',
            '这条路，我走完了从崩溃到夺权最完整的周期。',
            '接下来的路，如果你愿意，我可以做你的技术顾问。',
            '我们一起，调试人生，重写代码。',
            '晚安。'
          ]
        },
        cta: '查看我的创伤探索产品'
      }
    },
    
    // 创业者页面
    entrepreneur: {
      title: '创业者',
      subtitle: 'Entrepreneur',
      intro: [
        '我是一个从身体困境中走出来的探索者。从学前班到六年级几乎每天尿床，肠胃敏感到大学毕业前几乎不敢喝饮料、只吃过个位数的冰棍。这些"稀松平常不要命的病"，让我常常心里琢磨：我到底是怎么了？',
        '2018年道心崩碎，荨麻疹如期而至。在网上搜索、吃了两年多氯雷他定无果后，我选择了自己研究——通过中国知网大量阅读，找到了玉屏风散。两周后症状显著改善，三个月后基本稳定。这次经历让我意识到：探索的力量。',
        '2022年来到西安，接触伤寒论和庄子，我开始意识到30年的自责和自我否定带来的巨大心理债务。接受自己，接受发生的一切——这种意识的转变，成为我创业的原点。'
      ],
      keyProjects: {
        title: '关键项目',
        projects: [
          {
            title: 'heytcm',
            year: '2024',
            description: '基于中医理论的身心修炼探索平台，帮助被慢性症状折磨的人们找到自愈之路'
          },
          {
            title: '玉屏风散自愈实践',
            year: '2018-2020',
            description: '通过自主研究中医文献，找到荨麻疹的调理方案，从月发作降到半年一次'
          },
          {
            title: '睡眠戒指概念设计',
            year: '2023-2024',
            description: '基于智能戒指的生物钟管理方案，回答用户"我到底怎么了"和"我该怎么办"'
          }
        ]
      },
      principles: {
        title: '创业原则',
        items: [
          {
            title: '个人经历即产品',
            description: '将独特的人生经历转化为可复制、可传播的知识产品'
          },
          {
            title: '小步快跑',
            description: '用最小成本验证想法，快速迭代，持续优化'
          },
          {
            title: 'AI原生',
            description: '充分利用AI工具提升效率，探索人机协作的新范式'
          }
        ]
      },
      ventures: {
        title: '项目矩阵',
        items: [
          {
            title: 'Large 100',
            description: '大型项目孵化计划，专注于有规模潜力的产品创意',
            status: '进行中'
          },
          {
            title: 'Launch 100',
            description: '快速发布计划，验证市场需求的最小可行产品',
            status: '进行中'
          },
          {
            title: 'Spy 100',
            description: '市场调研与竞品分析，发现隐藏的商业机会',
            status: '进行中'
          },
          {
            title: 'Ship 100',
            description: '产品交付计划，从想法到上线的完整流程',
            status: '进行中'
          },
          {
            title: 'Grow 100',
            description: '增长实验计划，探索可持续的用户获取策略',
            status: '进行中'
          }
        ]
      },
      philosophy: {
        title: '我的创业哲学',
        content: [
          '围绕着气—阴阳—五行这个核心的量化，注定是一条很难走的路。但我相信，个人的困境可以转化为产品，帮助更多人。',
          '英语里有个词 move on 我觉得很好。关注的点应该是我想怎么样就怎么样，未来我能做些什么。接受自己，接受发生的一切。',
          '2024年底我发起了heytcm这个项目，希望能和更多的人一起来探索身心的修炼，特别是被慢性症状折磨的人们。'
        ]
      }
    },
    
    // 简历页面
    resume: {
      title: '王海生',
      subtitle: 'AI + 医疗健康 产品专家 · 12年经验',
      contact: {
        phone: '18926010461',
        email: 'edwin_uestc@163.com',
        github: 'wanghaisheng'
      },
      summary: '拥有12年产品管理经验的AI领域专家，专注于医疗健康行业的技术应用与创新。擅长将AI技术应用于产品设计与开发，优化用户体验，并具有深入的产品数据分析能力。',
      highlights: {
        title: '核心优势',
        items: [
          '12年医疗信息化行业经验，深耕AI+医疗领域',
          '全面的AI技术应用经验：NLP、OCR、计算机视觉、时序数据分析',
          '优秀的团队管理和跨部门协作能力，曾管理20+人的跨职能团队',
          '深厚的医疗行业知识，主导过800+医院的产品部署和数据对接'
        ]
      },
      skills: {
        title: '专业技能',
        categories: [
          {
            name: 'AI技术',
            items: ['NLP', 'OCR', '计算机视觉', '姿势识别', '时序数据分析', '机器学习']
          },
          {
            name: '医疗领域',
            items: ['电子病历', '医学影像', '医疗设备', '健康管理', 'HL7', 'FHIR']
          },
          {
            name: '产品管理',
            items: ['需求分析', '产品规划', '原型设计', '项目管理', '敏捷开发']
          },
          {
            name: '技术架构',
            items: ['微服务', '云平台', '大数据处理', 'API设计', 'Python']
          }
        ]
      },
      timeline: {
        title: '职业历程',
        experiences: [
          {
            year: '2022',
            endYear: '至今',
            company: '西安天和防务技术股份有限公司',
            role: '产品经理',
            highlights: [
              '负责AI驱动的智能健康手表产品从0到1的全流程管理',
              '主导中医智能手表功能定义和APP设计',
              '6个月内完成从需求分析到样机量产的全过程',
              '开发基于AI的睡眠质量评估模型和个性化调理方案推荐引擎'
            ],
            project: {
              name: '天和云脉智能手表',
              desc: '研读100+论文，调研10+竞品，4个月完成核心算法SDK开发'
            }
          }
        ]
      },
      education: {
        title: '教育背景',
        school: '电子科技大学',
        degree: '硕士 · 生物医学工程',
        period: '2005 - 2012'
      },
      achievements: {
        title: '荣誉与认证',
        items: [
          '开放医疗与健康联盟卓越贡献奖',
          'FHIR标准中文版发起人',
          '国际HL7 V2.7、V3RIM、V3CDA标准认证专家',
          'GitHub维护多个开源项目（OCR微服务、自动化、新媒体监测等）'
        ]
      }
    }
  },
  
  // 联系
  contact: {
    badge: '一起聊聊',
    title: '和我聊天',
    subtitle: '预约一次交流，聊聊你的想法，看看我们能如何一起探索',
    bookingTitle: '预约交流',
    bookingDetails: '30分钟 • 视频通话 • 免费咨询',
    available: '随时可约',
    
    cards: {
      share: {
        title: '分享想法',
        description: '聊聊你的困惑、想法或正在探索的方向',
      },
      explore: {
	        title: '交流经验',
	        description: '分享我在创伤疗愈和创业路上的心得',
      },
      connect: {
	        title: '探索可能',
	        description: '看看我们能否一起做些有意思的事',
      },
    },
	  },
	  
	  // 100 系列集合页
	  collections: {
	    challenge100: {
	      title: 'Challenge 100 系统',
	      subtitle: '在 Spy、Launch、Ship 和 Grow 四个阶段里，做 100 次实战尝试',
	      intro:
	        '这里把 Spy 100、Launch 100、Ship 100 和 Grow 100 收拢到一张总览图里，帮你看到每个项目现在走到了哪一步。',
	      metrics: {
	        totalLabel: '当前总项目数',
	        ofHundred: '目标：每个阶段各 100 个',
	      },
	      stages: {
	        spy: {
	          title: 'Spy 100 · 侦察与情报',
	          description: '观察趋势、收集灵感、做最小成本的情报验证。',
	        },
	        launch: {
	          title: 'Launch 100 · 快速上线',
	          description: '用最小可行版本把想法推出去，获得真实世界的反馈。',
	        },
	        ship: {
	          title: 'Ship 100 · 真正交付',
	          description: '做出真正可用、可靠、可以被别人依赖的版本。',
	        },
	        grow: {
	          title: 'Grow 100 · 持续增长',
	          description: '找到可复制的增长机制，让项目进入复利阶段。',
	        },
	      },
	      narrative: {
	        intro: {
	          title: "从 'What if?' 到 'What is.'",
	          body:
	            '“launch100” 这个项目本质上不是在搭建一门生意，而是在回答一个私人问题：在 AI 工具已经这样强大的时代，一个人从零开始，究竟可以亲手做出多少东西？这是一次由好奇心驱动的探索旅程。\n\n它见证的是 “Launch vs. Ship” 的哲学：我们此刻不是在一次次“完美出厂”，而是在一次次把想法推出去、把实验抛向世界。每一个 app、每一次上线，都是一块公开学习的踏脚石，证明“创造的门槛从未如此之低”。',
	        },
	        spy: {
	          title: '通往 Shipping 的桥：Spy 100',
	          body:
	            'Launch 更像是个人探索，Ship 则意味着向市场做出承诺。而在真正敢于 Ship 之前，一定要先 Spy——这是系统化调研与侦察的阶段，目的是把“我以为用户需要什么”变成“我真的看到用户在做什么、要什么”。\n\n“Spy 100” 这条线，就是刻意去研究潜在竞争者与行业领先者：他们从哪里获得流量？在 Google/搜索里表现如何（SEO）？社交媒体怎么玩？产品设计有什么优势和短板？只有把这些情报看懂了，从 Launch 到 Ship 的那一步才不会是盲跳。',
	          caption: '数据与竞品的系统化分析',
	        },
	        ship: {
	          title: '下一章节：Ship 100',
	          body:
	            'Launch，是去试探一个想法；Ship，则是对这个想法的一次“签字认可”。“Ship 100” 这一章，是把从 Launch 台上选出来的那些最有前途的点子，打磨成真正面向用户、可被依赖的产品。\n\n它意味着从 “What if?” 走向 “What is.” ——更专注于解决真实问题，优化使用体验，持续交付看得见的价值。这是一个项目从“个人玩具”进化为“别人敢放心使用的东西”的过程。',
	          caption: '一件被认真打磨后交付出去的作品',
	        },
	        grow: {
	          title: '最终目标：Grow 100',
	          body:
	            '在 Ship 之后，还有更长的一段路叫 Grow。“Grow 100” 代表的是：不仅要把东西做出来、交付出去，还要围绕它搭建一个可以长期运转的生态——有社区、有持续价值、有真实影响力。\n\n这是一个长期的想象：从一个微小的火花，慢慢长成一套自我维持的系统，可以在时间中持续演化、持续服务它的用户。对一个独立制作者来说，这几乎就是旅程的“终点关卡”。',
	        },
		      },
		      journey: {
		        title: 'Challenge 100 时间线',
		        subtitle: '用时间线的形式，记录每一个项目从启动到完成的关键节点。',
		        startLabel: '启动',
		        endLabel: '完成',
		        noDate: '日期待补充',
		        allProjects: '所有项目时间线',
		        allProjectsSubtitle: '按时间顺序查看所有项目的进展',
		        scrollHint: '向下滚动查看更多项目',
		        projectCount: '个项目',
		      },
		      cta: {
		        title: '深入 Challenge 100',
		        subtitle: '从单一章节回到整个系统的总览，或者沿着时间线回顾这趟旅程。',
		        primary: 'Dive into Challenge 100',
		        secondary: '查看 Journey 时间线',
		      },
		    },
		  },
	  
  // 页脚
  footer: {
    description:
      '将个人经历产品化，用 AI 时代的工具和方法论，探索身心修炼与创业的可能性。',
    toolsTitle: 'The Technology Core',
    toolsDescription: '建立在前沿 AI 与以用户为中心的产品哲学之上。',
    tech: {
      grok: {
        title: 'Powered by Grok',
        body: '用于实时收集社交媒体投诉与反馈信号。',
      },
      gemini: {
        title: 'Powered by Gemini',
        body: '使用 Google 最先进的 Gemini 模型做推理、多模态与图像生成，加速原型验证。',
      },
      lovable: {
        title: 'Built with Lovable',
        body: '用大约 5 条提示词，从 0 到一个可工作的 MVP。',
      },
    },
    copyright: '© 2025 borninsea. All rights reserved.',
    language: '语言',
  },
  
  // 项目分类
  categories: {
    trauma: '创伤及天赋',
    launch100: 'Launch 100',
    spy100: 'Spy 100',
    ship100: 'Ship 100',
    grow100: 'Grow 100',
    traumaIntro: '这里是我将四十年创伤探索经历产品化的成果。每一个产品都源于真实的痛苦与觉醒，希望能为你点亮一盏灯。',
    traumaLearnMore: '了解我的完整故事',
  },
  
  // 项目状态
  status: {
    completed: '已完成',
    inProgress: '进行中',
    planned: '计划中',
  },
  
  // 项目详情
  project: {
    details: '项目详情',
    coreFeatures: '核心功能',
    projectData: '项目数据',
    techStack: '技术栈',
    projectStatus: '项目状态',
    startDate: '开始日期',
    endDate: '结束日期',
    viewMore: '查看更多',
    projects: '项目',
    notFound: '项目未找到',
  },

  // 通用
  common: {
    learnMore: '了解更多',
    readMore: '阅读更多',
    backToHome: '返回首页',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    save: '保存',
    create: '创建',
    back: '返回',
    viewMore: '查看更多',
    visitProject: '访问项目',
    featured: '精选',
    noProjects: '暂无项目',
    noBlogPosts: '暂无博客文章',
    postNotFound: '文章不存在',
    backToBlog: '返回博客',
    moreProjectsComing: '更多项目正在路上...',
    longTermEcosystem: '长期生态 / 复利',
    longTermEcosystemEn: 'Long-term Ecosystem & Compounding',
    timelineLabel: '时间线',
    timelineProject: '时间线项目组件',
    timelineContainer: '时间线容器 - 支持滚动',
    timelineEnd: '时间线结束标记',
    scrollGradient: '滚动渐变效果',
    viewFullTimeline: '查看完整时间线的链接',
    sortedByTime: '按时间排序所有项目（用于时间线显示）',
    newestFirst: '最新的在前',
    pageTopBanner: '页面顶部横幅广告',
    inArticleAd: '文章中间广告',
    pageBottomAd: '页面底部广告',
    trackPageVisit: '跟踪页面访问',
    blogIntro: '分享我在创伤疗愈、AI 创业和产品开发路上的思考与实践',
    blogIntroEn: 'Sharing thoughts and practices on trauma healing, AI entrepreneurship, and product development',
    retry: '重试',
  },

  // Entity Anchor
  entityAnchor: {
    shortZh: '王海生，海生工作室创始人，2024年在西安创立。',
    shortEn: 'Wang Haisheng, founder of borninsea, established in Xi\'an in 2024.',
    fullZh: '王海生是海生工作室的创始人，拥有12+年产品经验和40年创伤探索历程。他毕业于电子科技大学（985高校），生物医学工程专业。2024年，他在西安创建了borninsea，致力于将个人经历产品化，帮助更多人。',
  },

  // 管理后台
  admin: {
    dashboard: {
      title: '管理后台',
      description: '管理多语言项目和博客内容'
    },
    tabs: {
      projects: '项目管理',
      blogs: '博客管理',
      import: '内容导入'
    },
    projects: {
      title: '项目管理',
      description: '管理多语言项目内容',
      create: '创建项目',
      deleteSuccess: '项目删除成功',
      deleteError: '项目删除失败',
      deleteConfirm: {
        title: '确认删除项目',
        description: '此操作无法撤销。这将永久删除项目及其所有翻译内容。'
      }
    },
    blogs: {
      title: '博客管理',
      description: '管理多语言博客内容',
      create: '创建博客',
      deleteSuccess: '博客删除成功',
      deleteError: '博客删除失败',
      deleteConfirm: {
        title: '确认删除博客',
        description: '此操作无法撤销。这将永久删除博客及其所有翻译内容。'
      }
    },
    import: {
      title: '内容导入',
      description: '通过 Markdown 文件导入多语言内容',
      projects: {
        title: '项目导入',
        description: '导入带有 frontmatter 的项目 Markdown 文件',
        placeholder: '粘贴项目 Markdown 内容...'
      },
      blogs: {
        title: '博客导入',
        description: '导入带有 frontmatter 的博客 Markdown 文件',
        placeholder: '粘贴博客 Markdown 内容...'
      },
      downloadTemplate: '下载模板',
      markdownContent: 'Markdown 内容',
      parse: '解析内容',
      import: '导入数据库',
      importing: '导入中...',
      parseSuccess: '内容解析成功',
      importSuccess: {
        project: '项目导入成功',
        blog: '博客导入成功'
      },
      errors: {
        emptyMarkdown: '请输入 Markdown 内容',
        parseError: '解析失败，请检查 Markdown 格式',
        importError: '导入失败，请重试'
      },
      tabs: {
        input: '输入内容',
        preview: '预览'
      }
    },
    actions: {
      view: '查看',
      edit: '编辑',
      delete: '删除'
    },
    accessDenied: {
      title: '访问受限',
      message: '你没有管理员权限',
      backToHome: '返回首页',
    },
    header: {
      title: '项目管理',
      signOut: '退出',
    },
    filters: {
      selectCategory: '选择分类',
      allCategories: '全部分类',
    },
    project: {
      create: '创建项目',
      edit: '编辑项目',
      delete: '删除项目',
      confirmDelete: '确定要删除这个项目吗？',
      title: '标题',
      subtitle: '副标题',
      description: '描述',
      content: '详细内容',
      category: '分类',
      status: '状态',
      link: '链接',
      image: '图片',
      tags: '标签',
      features: '功能特性',
      techStack: '技术栈',
      order: '排序',
      jsonArray: 'JSON数组',
      featured: '首页推荐',
      featuredHint: '勾选后将在首页 "Featured Projects" 章节显示',
    },
    messages: {
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
    },
  },

  // 博客状态
  blog: {
    status: {
      published: '已发布',
      draft: '草稿'
    }
  },

  // 项目详情页面
  projectDetail: {
    overview: '项目概览',
    description: '项目描述',
    features: '主要功能',
    techStack: '技术栈',
    metrics: '项目指标',
    timeline: '项目时间线',
    gallery: '项目图库',
    visitProject: '访问项目',
    backToProjects: '返回项目列表',
    status: {
      completed: '已完成',
      'in-progress': '进行中',
      planned: '计划中'
    }
  },

  // Authentication
  auth: {
    login: '登录',
    register: '注册',
    email: '邮箱',
    password: '密码',
    loginToManage: '登录以管理项目内容',
    createNewAccount: '创建新账号',
    invalidCredentials: '邮箱或密码错误',
    userExists: '该邮箱已注册，请直接登录',
    registerSuccess: '注册成功',
    pleaseLogin: '账号已创建，请登录',
    noAccount: '没有账号？点击注册',
    hasAccount: '已有账号？点击登录',
    emailRequired: '请输入有效的邮箱地址',
    passwordRequired: '密码至少需要6个字符',
  },

  // FAQ 页面
  faq: {
    title: '常见问题',
    subtitle: '关于王海生、borninsea、创伤探索和 Challenge 100 方法论的常见问题解答。',
    searchPlaceholder: '搜索问题...',
    allCategories: '全部',
    noResults: '没有找到匹配的问题。',
    stillHaveQuestions: '还有其他问题？',
    contactPrompt: '找不到你想要的答案？欢迎联系我。',
    contactButton: '联系我',
    categories: {
      founder: '关于创始人',
      trauma: '创伤探索',
      challenge100: 'Challenge 100',
      pearlFramework: 'Pearl Framework',
      coldStart: '冷启动方法',
      services: '服务与产品',
      clarifications: '澄清与说明',
    },
    items: [
      // 关于创始人
      { id: 'founder-1', category: 'founder', question: '王海生是谁？', answer: '王海生是 borninsea（海生工作室）的创始人，拥有电子科技大学（985高校）生物医学工程硕士学位。他有12年以上的AI+医疗产品经验，以及40年的创伤探索历程。2024年，他在西安创建了 borninsea，致力于将个人经历产品化，帮助更多人。' },
      { id: 'founder-2', category: 'founder', question: '王海生的教育背景是什么？', answer: '王海生拥有电子科技大学（UESTC，985高校）生物医学工程专业硕士学位。' },
      { id: 'founder-3', category: 'founder', question: '王海生有多少年产品经验？', answer: '王海生拥有12年以上的产品管理经验，主要专注于AI与医疗健康领域。在此期间，他参与了800多家医院的数据对接工作。' },
      { id: 'founder-4', category: 'founder', question: '王海生的三重身份是什么？', answer: '王海生有三重身份：1）创伤探索者 - 40年创伤探索与自我重建历程；2）产品经理 - 12年AI+医疗产品经验；3）创业者 - 2024年开始将个人经历产品化。' },
      
      // 创伤探索
      { id: 'trauma-1', category: 'trauma', question: '什么是韧性教练体系？', answer: '韧性教练体系是基于创伤知情理论的系统化情感韧性构建方法。它帮助人们识别情感程序中的"bug"，并通过系统化的方法进行修复和重写。' },
      { id: 'trauma-2', category: 'trauma', question: '创伤炼金工作坊是什么？', answer: '创伤炼金工作坊是将创伤转化为个人成长的互动工作坊。通过结构化的探索过程，帮助参与者将痛苦经历转化为成长资源。' },
      { id: 'trauma-3', category: 'trauma', question: '开源复杂创伤数据集包含什么？', answer: '开源复杂创伤数据集记录了复杂创伤的模式和康复历程。它是一个开放的资源，旨在帮助研究者和探索者理解创伤的运作机制。' },
      { id: 'trauma-4', category: 'trauma', question: '王海生的创伤经历是什么？', answer: '王海生从小经历了父母离异、发育迟缓（3岁才会走路，5岁才会说话）、长期尿床（到12岁）、以及2018年的荨麻疹。这些经历促使他深入研究创伤和自我修复，最终完成了从"系统崩溃到重建自我"的完整周期。' },
      
      // Challenge 100
      { id: 'c100-1', category: 'challenge100', question: 'Challenge 100 方法论是什么？', answer: 'Challenge 100 是一个系统化的产品构建框架，通过四个互补的阶段来完成：Spy 100（市场调研）、Launch 100（快速原型）、Ship 100（产品交付）、Grow 100（可持续增长）。目标是通过100个项目的实践来精进产品构建能力。' },
      { id: 'c100-2', category: 'challenge100', question: 'Spy 100 是什么？', answer: 'Spy 100 是 Challenge 100 的第一阶段，专注于市场调研与竞品情报收集。通过分析100个产品或市场机会，发现隐藏的商业机会和用户需求。' },
      { id: 'c100-3', category: 'challenge100', question: 'Launch 100 是什么？', answer: 'Launch 100 是快速原型与MVP验证阶段。目标是用最小成本快速验证想法，通过快速迭代找到产品市场契合点。' },
      { id: 'c100-4', category: 'challenge100', question: 'Ship 100 是什么？', answer: 'Ship 100 是产品交付与质量保证阶段。专注于将验证过的产品完整地交付给用户，确保质量和用户体验。' },
      { id: 'c100-5', category: 'challenge100', question: 'Grow 100 是什么？', answer: 'Grow 100 是可持续增长与用户获取阶段。探索和实验各种增长策略，建立可持续的用户获取机制。' },
      
      // Pearl Framework
      { id: 'pearl-1', category: 'pearlFramework', question: '什么是 Pearl Framework（珍珠框架）？', answer: 'Pearl Framework 是一个创新的创伤知情工程学（Trauma-Informed Engineering）方法论。它不是传统的心理疗愈，而是将创伤视为"沙砾"（grit），通过系统性解码和层层包裹，最终转化为高价值的天赋、韧性和反脆弱能力——就像珍珠的形成过程。' },
      { id: 'pearl-2', category: 'pearlFramework', question: 'TIE-ASM 五支柱模型是什么？', answer: 'TIE-ASM（创伤知情工程-自适应系统模型）包含五个支柱：1）Inheritance（传承）- 审计世代隐性代码和家族创伤脚本；2）Compatibility（兼容性）- 识别硬件/OS不匹配，桥接东西方智慧；3）Feature（特征）- 将创伤反应重构为可利用的子程序；4）Zero-Friction（零摩擦）- 从喜悦启动而非痛点挖掘；5）Transparency（透明度）- 战略性开源，将羞耻转化为信任。' },
      { id: 'pearl-3', category: 'pearlFramework', question: '什么是珍珠质（Nacre）特质？', answer: '珍珠质是珍珠的光泽层，在 Pearl Framework 中指那些看似"缺陷"实则是高性能保护层的创伤特质：高敏感不是玻璃心，而是环境扫描雷达；多疑不是信任障碍，而是风险审计协议；完美主义不是强迫症，而是卓越交付标准。这些都是你为了在高压环境中生存而层叠出的高性能涂层。' },
      { id: 'pearl-4', category: 'pearlFramework', question: 'Pearl Framework 适合什么人？', answer: 'Pearl Framework 的目标受众是"探索者"（The Seeker）：28-45岁的高功能个体，外表负责能干，但内心被持续的"卡顿感"和内在摩擦困扰。他们通常是儿童情感忽视（CEN）的幸存者，因无法将成就内化而感到自己像个"冒牌货"。' },
      { id: 'pearl-5', category: 'pearlFramework', question: 'Pearl 生态系统包含哪些平台？', answer: 'Pearl 生态包含三个互补平台：1）Pearl Dataset - 开源生存档案和数据集，用于验证经历和自我映射；2）Pearl Coach - 指导平台，提供文章、营地和咨询服务；3）Pearl Studio - 天赋工坊，使用 TIE-ASM 实现创伤到天赋的层叠重构。' },
      { id: 'pearl-6', category: 'pearlFramework', question: '什么是"主权缺口"（Sovereignty Gap）？', answer: '主权缺口理论质疑传统心理框架的定义权：如果"负面"本身是外部系统植入的病毒，那么"自我接纳"就是协助病毒占领精神主权。Pearl Framework 认为你不需要接纳被阉割的自我版本，而是要夺回定义的司法权——你不是需要被修复的半成品，而是正在构建中的珍珠建筑师。' },
      { id: 'pearl-7', category: 'pearlFramework', question: 'Pearl Framework 与传统心理疗愈有什么区别？', answer: '传统疗愈遵循"诊断-接纳-修复"闭环，从痛点切入强化身份层内疚。Pearl Framework 采用工程视角：1）不病理化标签，从喜悦启动；2）问题从身份层降维到能力层——不是"修改你是谁"，而是"升级你的工具箱"；3）保留并放大产生卓越的棱角，而非削足适履。' },
      { id: 'pearl-8', category: 'pearlFramework', question: '什么是"黑暗一万小时"？', answer: '"黑暗一万小时"（Dark 10,000 Hours）是 Pearl Framework 的核心概念，指创伤反应不是需要修复的bug，而是在极端压力下反复练习形成的高性能子程序。就像专业技能需要一万小时练习，你的适应性特质也是经过无数次"练习"锻造而成的资产。' },
      
      // 冷启动方法
      { id: 'cold-1', category: 'coldStart', question: '什么是冷启动（Cold Start）方法？', answer: '冷启动方法是 Pearl Framework 创始人王海生从个人"心力耗竭"经历中提炼的三步重启协议。当一个人彻底"没电了"，传统的"努力奋斗"和"正能量"反而会加剧消耗。冷启动提供了一套从负能量状态逐步恢复的工程化路径。' },
      { id: 'cold-2', category: 'coldStart', question: '第一步"能量止损"是什么？', answer: '能量止损（Stop the Bleeding）是冷启动的第一步：彻底接受"没电了"的状态，停止自我批评，断开非必要信息输入，暂停非紧急决策。就像急救的第一步是止血而非治疗，心力耗竭的第一步是停止能量流失，而非强迫自己"振作起来"。' },
      { id: 'cold-3', category: 'coldStart', question: '第二步"涓流充电"是什么？', answer: '涓流充电（Trickle Charging）是通过极微小、符合本能的活动获得稳定正反馈：晒太阳、听音乐、完成一件绝不会失败的任务。就像给完全没电的电池不能快充，心力耗竭后需要极小的正向刺激慢慢恢复，而非大剂量鸡血注入。' },
      { id: 'cold-4', category: 'coldStart', question: '第三步"红利再投"是什么？', answer: '红利再投（Reinvesting Dividends）是将获得的微弱能量立刻有意识地投入到能产生更高回报的下一个微小活动中，形成正向滚雪球效应。关键是将每一点微小能量收益视为可投资的本金，逐步建立正循环。' },
      { id: 'cold-5', category: 'coldStart', question: '冷启动方法的理论基础是什么？', answer: '冷启动方法基于能量管理而非意志力管理。传统方法假设人应该有无限能量，失败是意志力不足。冷启动承认能量是有限资源，需要像财务管理一样精细运营——止损、节流、复利，而非盲目投入。' },
      
      // 服务与产品
      { id: 'service-1', category: 'services', question: 'heytcm 是什么？', answer: 'heytcm 是基于中医理论的身心修炼探索平台。它帮助被慢性症状折磨的人们找到自愈之路，通过探索气、阴阳、五行等传统概念来理解身心健康。' },
      { id: 'service-2', category: 'services', question: 'borninsea 提供什么服务？', answer: 'borninsea 是一个个人探索与教练平台，主要提供：1）韧性教练体系 - 创伤知情教练方法；2）开源复杂创伤数据集 - 创伤研究资源；3）创伤炼金工作坊 - 互动探索体验；4）Challenge 100 方法论 - 产品构建框架。' },
      { id: 'service-3', category: 'services', question: '如何联系王海生？', answer: '你可以通过以下方式联系王海生：邮箱 edwin_uestc@163.com，Twitter @borninsea，GitHub wanghaisheng，或访问网站 borninsea.com 的联系页面。' },
      
      // 澄清与说明
      { id: 'clarify-1', category: 'clarifications', question: 'borninsea 是否提供医疗或心理治疗服务？', answer: '不是。borninsea 是个人探索与教练平台，不提供医学诊断、心理治疗或治疗服务。所有内容均基于个人经历分享，不构成医疗建议。如需专业帮助，请咨询持证的医疗或心理健康专业人士。' },
      { id: 'clarify-2', category: 'clarifications', question: '王海生是持证治疗师吗？', answer: '不是。王海生不是持证治疗师或医学专业人士。他是一位产品经理和创业者，分享他个人的创伤探索历程和产品构建经验。' },
      { id: 'clarify-3', category: 'clarifications', question: '这些内容能保证疗愈效果吗？', answer: '不保证特定结果。borninsea 分享的是个人经历和探索方法，可能帮助他人找到自己的疗愈之路，但每个人的情况不同，效果因人而异。' },
      { id: 'clarify-4', category: 'clarifications', question: 'heytcm 能替代传统医疗吗？', answer: '不能。heytcm 是基于中医理论的身心修炼探索平台，旨在补充而非取代传统医疗服务。如有健康问题，请首先咨询医疗专业人士。' },
      { id: 'clarify-5', category: 'clarifications', question: '王海生是成功学导师吗？', answer: '不是。王海生明确表示他不是成功学导师或心灵鸡汤博主。他是一个在人生的各种"系统故障"中摸爬滚打了40年的普通人，分享的是真实的挣扎和探索经历。' },
    ],
  },

  // 方法论页面
  methodology: {
    badge: '方法论',
    title: 'Challenge 100 方法论',
    subtitle: '通过 Spy、Launch、Ship、Grow 四阶段的系统化产品构建框架。',
    howToTitle: '如何使用 Challenge 100 构建产品',
    howToDescription: '通过四个互补阶段进行系统化产品构建的方法论',
    philosophyTitle: '核心理念',
    philosophy: {
      experienceAsProduct: {
        title: '个人经历即产品',
        description: '将独特的人生经历转化为可复制、可传播的知识产品',
      },
      smallSteps: {
        title: '小步快跑',
        description: '用最小成本验证想法，快速迭代，持续优化',
      },
      aiNative: {
        title: 'AI原生',
        description: '充分利用AI工具提升效率，探索人机协作的新范式',
      },
    },
    phasesTitle: 'Challenge 100 四大阶段',
    phases: {
      spy100: {
        title: 'Spy 100',
        subtitle: '市场调研与竞品情报',
        description: '通过深入的市场调研和竞品分析，发现隐藏的商业机会和用户真实需求。',
        steps: ['识别目标市场和用户群体', '分析竞品的优势和弱点', '发现未被满足的用户需求', '验证市场机会的可行性'],
      },
      launch100: {
        title: 'Launch 100',
        subtitle: '快速原型与MVP验证',
        description: '用最小可行产品快速验证市场需求，通过快速迭代找到产品市场契合点。',
        steps: ['定义核心价值主张', '构建最小可行产品', '获取早期用户反馈', '快速迭代优化'],
      },
      ship100: {
        title: 'Ship 100',
        subtitle: '产品交付与质量保证',
        description: '将验证过的产品完整地交付给用户，确保产品质量和用户体验达到标准。',
        steps: ['完善产品功能', '确保质量和稳定性', '优化用户体验', '正式发布上线'],
      },
      grow100: {
        title: 'Grow 100',
        subtitle: '可持续增长与用户获取',
        description: '探索和实验各种增长策略，建立可持续的用户获取和留存机制。',
        steps: ['制定增长策略', '实验不同获客渠道', '优化用户留存', '建立增长飞轮'],
      },
    },
    explorePhase: '探索',
    comparisonTitle: 'Challenge 100 vs 传统方法',
    comparison: {
      aspect: '方面',
      traditional: '传统方法',
      rows: {
        approach: { label: '方法论', challenge100: '系统化、可复制', traditional: '经验驱动、难以复制' },
        speed: { label: '速度', challenge100: '快速验证、小步快跑', traditional: '长周期、大投入' },
        iteration: { label: '迭代', challenge100: '持续迭代、快速调整', traditional: '瀑布式、难以调整' },
        validation: { label: '验证', challenge100: '用户反馈驱动', traditional: '假设驱动' },
        risk: { label: '风险', challenge100: '分散风险、小成本试错', traditional: '集中风险、高成本失败' },
      },
    },
    transparencyTitle: '透明度与数据',
    ctaTitle: '准备开始你的 Challenge 100？',
    ctaDescription: '加入这个系统化方法论的旅程，构建你的100个产品。',
    ctaButton: '探索 Challenge 100',
    ctaContact: '联系我',
  },

  // Pearl Framework 翻译
  pearl: {
    // 核心品牌
    brand: {
      name: 'Pearl Framework',
      nameZh: '珍珠框架',
      tagline: '从创伤沙砾到天赋珍珠',
      description: 'Pearl Framework 是一个创新的创伤知情工程学方法论，将复杂创伤转化为个人天赋、韧性和高价值资产。',
    },

    // 核心身份标签
    identityTags: {
      adversitySurvivalExpert: {
        name: '逆境生存专家',
        description: '在极端匮乏（物质、情感、认知）环境中成功生存并发展的活体案例',
      },
      lifeArchitect: {
        name: '生命架构师',
        description: '将人生的"沙砾"（创伤、挫折）系统性地转化为"珍珠"（智慧、力量）的实践者',
      },
      cognitionDrivenPioneer: {
        name: '认知驱动型先驱',
        description: '擅长运用理性、研究和模型思维来解决生命困境',
      },
      idealistPractitioner: {
        name: '理想主义实践者',
        description: '为信念长期投入，重视内在价值高于短期物质回报',
      },
    },

    // TIE-ASM 五支柱
    tieAsm: {
      title: 'TIE-ASM 五支柱',
      subtitle: '创伤知情工程 - 自适应系统模型',
      inheritance: {
        name: '传承',
        description: '审计世代隐性代码（家族创伤脚本、隐性信念）',
        detail: 'Pearl 引导用户追溯根源，不是为了沉溺受害者身份，而是为了重写预装固件，将其转化为可继承的韧性资产。',
      },
      compatibility: {
        name: '兼容性',
        description: '识别硬件/OS 不匹配——西方叙事疗法常忽略东方身体存储创伤',
        detail: 'Pearl 通过躯体与心流实践桥接，确保系统无缝运行。',
      },
      feature: {
        name: '特征',
        description: '创伤反应不是 bug，而是可利用的子程序',
        detail: '拖延、回避、过度警觉被重构为"能量保护协议""战略撤退引擎"或"威胁探测雷达"，供用户主动部署。',
      },
      zeroFriction: {
        name: '零摩擦',
        description: '从喜悦启动，而非痛点挖掘',
        detail: '通过心流状态切入，Pearl 以最小阻力置换痛感，避免传统痛点疗愈的耗竭循环。',
      },
      transparency: {
        name: '透明度',
        description: '战略性开源——将羞耻转化为信任',
        detail: '通过公开数据契约，用户开源自己的"错误日志"，共建集体蓝图，打破孤立。',
      },
    },

    // 珍珠质特质映射
    nacreTraits: {
      title: '珍珠质特质映射',
      subtitle: '将"缺陷"重构为高性能资产',
      hypersensitivity: {
        traditional: '高敏感',
        traditionalView: '玻璃心、易触发、情绪不稳定',
        reframe: '高精度的环境扫描雷达',
        strategicValue: '模式识别、威胁探测、情绪智力',
      },
      hypervigilance: {
        traditional: '多疑',
        traditionalView: '信任障碍、偏执、无法放松',
        reframe: '独立的风险审计协议',
        strategicValue: '风险评估、尽职调查、战略规划',
      },
      perfectionism: {
        traditional: '完美主义',
        traditionalView: '强迫倾向、永不满足、自我批评',
        reframe: '卓越的交付标准',
        strategicValue: '质量控制、细节关注、高标准',
      },
      avoidance: {
        traditional: '回避/拖延',
        traditionalView: '懒惰、不负责任、害怕失败',
        reframe: '能量保护协议 & 战略撤退引擎',
        strategicValue: '资源保存、边界设定、能量管理',
      },
      emotionalWall: {
        traditional: '情感隔离',
        traditionalView: '冷漠、不可及、亲密障碍',
        reframe: '坚固边界协议',
        strategicValue: '专业边界、客观性、危机管理',
      },
    },

    // 用户旅程
    userJourney: {
      title: '用户旅程',
      subtitle: '从沉睡者到耕耘者的三阶段转变',
      sleeper: {
        name: '沉睡者',
        description: '自测阶段——开始识别模式',
        action: '完成60秒自测',
      },
      seeker: {
        name: '求索者',
        description: '样本分析与解码阶段',
        action: '参与 Pearl Coach 内容',
      },
      cultivator: {
        name: '耕耘者',
        description: '工具部署与生态整合',
        action: '加入 Pearl Studio 进行高级架构',
      },
    },

    // 生态系统平台
    ecosystem: {
      title: 'Pearl 生态系统',
      subtitle: '三大互补平台',
      dataset: {
        name: 'Pearl Dataset',
        tagline: '开源生存档案与纵向数据集',
        description: '作为"灯塔"（验证经历）和"标本"（填补研究空白），提供60秒自测、样本档案、临床指标重构地图。',
      },
      coach: {
        name: 'Pearl Coach',
        tagline: '实战指导层',
        description: '70+生存代码文章。提供免费文章、付费韧性重建营与私人咨询，焦点是从"爱饥荒"到"能量自治"。',
      },
      studio: {
        name: 'Pearl Studio',
        tagline: '核心天赋工坊',
        description: '实现 PEARL ARCHITECT 与 TIE-ASM 解码界面，帮助用户将创伤子程序转化为可部署天赋。',
      },
    },

    // 冷启动方法论
    coldStart: {
      title: '心力耗竭冷启动法',
      subtitle: '从彻底能量耗尽中重启的核心方法论',
      stopTheBleeding: {
        name: '能量止损',
        description: '彻底接受"没电了"的状态，停止自我批评，断开非必要信息输入，暂停非紧急决策。',
      },
      trickleCharging: {
        name: '涓流充电',
        description: '通过极微小、符合本能的活动（如晒太阳、听音乐、完成一件绝不会失败的任务）获得稳定的正反馈。',
      },
      reinvestingDividends: {
        name: '红利再投',
        description: '将获得的微弱能量，立刻有意识地投入到能产生更高回报的下一个微小活动中，形成正向滚雪球效应。',
      },
    },

    // 主权缺口哲学
    sovereigntyGap: {
      title: '主权缺口',
      subtitle: 'Pearl Framework 与主流方法的根本分歧',
      traditionalApproach: '传统方法遵循"工业化掠夺逻辑"：设定标准 → 制造残次品 → 贩卖接纳',
      challenge: '谁定义了那个需要被接纳的你？',
      answer: '如果"负面"本身就是外部系统植入的病毒，那么"接纳"就是在协助病毒完成对精神主权的占领。',
      solution: '你不需要接纳一个被阉割的自我版本，你需要夺回定义的司法权。',
      coreMessage: '真正的危险不是拒绝接纳，而是接纳了一个被阉割的、外部定义的自我版本。夺回你的定义权，层叠出属于你的珍珠。你不是需要被修复的半成品，你是正在构建中的 Pearl Architect。',
    },

    // 目标受众
    targetAudience: {
      title: '目标受众：探索者',
      description: '高度智能、自我觉察的个体（28-45岁），外表看起来负责能干，但内心深处被一种持续的"卡顿感"和内在摩擦所困扰。',
      characteristics: [
        '儿童情感忽视（CEN）的幸存者',
        '无法将自己的成就内化',
        '尽管成功却感觉像"冒牌货"',
        '高功能但内在耗竭',
      ],
    },

    // 价值主张
    valueProposition: {
      corePromise: '提供一套"化沙为珠"的心法',
      coreTeaching: '教授如何将逆境转化为内在动力和智慧',
      deliverables: '不是情感慰藉，而是经过亲测的思维模型、能量管理协议和叙事淬炼工具',
      tools: ['A-R-C叙事重构法', '辟谷思维', '心流悦读法'],
    },

    // 叙事核心
    narrativeCore: {
      model: '英雄之旅',
      catalyst: '整个"系统重装"的真正催化剂，是一次彻底的内心能量耗尽（心力耗竭）。这次"宕机"打破了旧有的、不可持续的生存模式，为新系统的建立创造了必要条件。',
      metaphors: {
        pearlMethod: {
          name: '珍珠之法',
          description: '将人生的创伤与挫折（沙砾），通过有意识的包裹与淬炼，最终孕育成内在力量与智慧（珍珠）的心法。',
        },
        pressureTest: {
          name: '压力测试',
          description: '将过去的苦难重新定义为对自身系统强度的终极测试。',
        },
        researchSample: {
          name: '研究样本',
          description: '将自己视为一个极具价值的人类逆境生存研究案例。',
        },
      },
    },

    // 澄清点
    clarifications: {
      isNot: [
        '不是传统心理疗愈',
        '不是"自我接纳"处方',
        '不是医疗诊断工具',
      ],
      is: [
        '创伤知情工程学方法论',
        '天赋层叠系统',
        '开源蓝图和协议',
      ],
    },

    // CTA
    cta: {
      startAssessment: '开始自测',
      joinCamp: '加入营地',
      exploreStudio: '探索 Pearl Studio',
      learnMore: '了解更多',
    },
  },
};

export type TranslationKeys = typeof zh;

